module.exports = __webpack_public_path__ + "img/oh-no.85567a66.png";